import { render, staticRenderFns } from "./DashboardWrapper.vue?vue&type=template&id=b0e71d5c&"
import script from "./DashboardWrapper.vue?vue&type=script&lang=js&"
export * from "./DashboardWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports